import $http from './http'
import config from './config'

export default {
  name: 'order',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getAllOrderList(data) {
    return $http.post(this.getUrl(`/Order/List`), data);
  },
}



// WEBPACK FOOTER //
// ./src/apis/orderApis.js